import { Component, Input, Output, EventEmitter, forwardRef, ElementRef, HostListener, ViewChild } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
  selector: 'welldone-multiselect',
  templateUrl: './welldone-multiselect.component.html',
  styleUrls: ['./welldone-multiselect.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => WelldoneMultiselectComponent),
      multi: true
    }
  ]
})
export class WelldoneMultiselectComponent implements ControlValueAccessor {
  @Input() data: any[] = [];
  @Input() placeholder: string = 'Seleziona...';
  @Input() settings: any = {};
  // Opt-in: `settings.singleSelection` is already passed by multi-select callers, so it can't be honored safely
  @Input() single = false;
  @Output() onFilterChange = new EventEmitter<string>();
  @Output() onSelect = new EventEmitter<any>();
  @Output() onDeSelect = new EventEmitter<any>();
  @ViewChild('searchInput') searchInput!: ElementRef;

  isOpen = false;
  searchText = '';
  private _searchText = '';
  selectedItems: any[] = [];
  
  // Default settings
  idField = 'id';
  textField = 'name';
  allowSearchFilter = true;

  onChange: any = () => {};
  onTouched: any = () => {};

  constructor(private elementRef: ElementRef) {}

  async ngOnInit() {
    console.log('Well Done WebApp - UI Version 2.7 Loaded');
    this.idField = this.settings.idField || 'id';
    this.textField = this.settings.textField || 'name';
    this.allowSearchFilter = this.settings.allowSearchFilter !== undefined ? this.settings.allowSearchFilter : true;
  }

  get filteredData() {
    if (this.onFilterChange.observers.length > 0) {
      return this.data;
    }
    if (!this.searchText) {
      return this.data;
    }
    return this.data.filter(item => 
      item[this.textField] && item[this.textField].toLowerCase().includes(this.searchText.toLowerCase())
    );
  }

  handleSearchInput(event: any) {
    const value = event.target.value;
    this.searchText = value;
    this.onFilterChange.emit(value);
  }

  toggleDropdown() {
    this.isOpen = !this.isOpen;
    if (this.isOpen && this.allowSearchFilter) {
      setTimeout(() => {
        this.searchInput.nativeElement.focus();
      }, 0);
    }
  }

  @HostListener('document:click', ['$event'])
  closeDropdown(event: Event) {
    if (!this.elementRef.nativeElement.contains(event.target)) {
      this.isOpen = false;
    }
  }

  isSelected(item: any): boolean {
    return this.selectedItems.some(i => i[this.idField] === item[this.idField]);
  }

  toggleItem(item: any) {
    if (this.single) {
      this.selectedItems = [item];
      this.isOpen = false;
      this.onSelect.emit(item);
      this.onChange(this.selectedItems);
      this.onTouched();
      return;
    }
    const index = this.selectedItems.findIndex(i => i[this.idField] === item[this.idField]);
    if (index >= 0) {
      this.selectedItems.splice(index, 1);
      this.onDeSelect.emit(item);
    } else {
      this.selectedItems.push(item);
      this.onSelect.emit(item);
    }
    this.onChange(this.selectedItems);
    this.onTouched();
  }

  removeItem(item: any, event: Event) {
    event.stopPropagation();
    this.selectedItems = this.selectedItems.filter(i => i[this.idField] !== item[this.idField]);
    this.onDeSelect.emit(item);
    this.onChange(this.selectedItems);
    this.onTouched();
  }

  // ControlValueAccessor methods
  writeValue(value: any): void {
    this.selectedItems = value || [];
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }
}
